export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 10_03.30ae8c33.jpg";